import React from 'react'
import { FaMagnifyingGlass } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";

const Searchbar = ({ value, onChange, hanleSearch, onClearSearch }) => {
    return (
        <div className='w-80 flex items-center px-2 bg-slate-100 rounded-md' >
            <input type="text" id="simple-search" class=" text-gray-900 text-sm bg-slate-100  block w-full ps-10 p-2.5 outline-none" placeholder='Search'
                value={value}
                onChange={onChange}
                required />

            {value && (<IoMdClose className='cursor-pointer mr-4' size={22} onClick={onClearSearch} />)}
            <FaMagnifyingGlass className='cursor-pointer mr-4' size={22} onClick={hanleSearch} />


        </div>
    )
}

export default Searchbar
